import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor;
import Component from "@glimmer/component";
import { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import isElementInViewport from "discourse/lib/is-element-in-viewport";
import { userPath } from "discourse/lib/url";
import { bind } from "discourse-common/utils/decorators";
let WatchRead = (_class = class WatchRead extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    if (!this.currentUser || this.currentUser.read_faq) {
      return;
    }
    this._checkIfRead();
    window.addEventListener("resize", this._checkIfRead, false);
    window.addEventListener("scroll", this._checkIfRead, false);
  }
  willDestroy() {
    super.willDestroy(...arguments);
    window.removeEventListener("resize", this._checkIfRead);
    window.removeEventListener("scroll", this._checkIfRead);
  }
  async _checkIfRead() {
    const lastParagraph = document.querySelector("[itemprop='mainContentOfPage'] > *:last-child");
    if (!isElementInViewport(lastParagraph)) {
      return;
    }
    await ajax(userPath("read-faq"), {
      type: "POST"
    });
    this.currentUser.set("read_faq", true);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_checkIfRead", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "_checkIfRead"), _class.prototype)), _class);
export { WatchRead as default };